import { Box, CircularProgress, Grid } from "@mui/material"
import { useOrderFiltersListQuery } from "../../store"
import { FormContainer, useForm } from "react-hook-form-mui"
import { useWatch } from "react-hook-form"
import { ADV } from "../../interfaces"
import { useEffect, useRef } from "react"
import equal from "fast-deep-equal"
import { useUrlFilters } from "@core/hooks"
import { cleanFilters } from "@core/utils"
import { ORDER_FILTER_SCHEMA } from "../../constants"
import { Filter } from "./filter"

const FILTERS_LABELS: { [key: string]: string } = {
  statuses: "Статус",
  agent_types: "Тип контрагента",
  agents: "Контрагент",
  campaigns: "Кампания",
  types: "Тип",
  referral_codes: "Реф. код",
  geos: "Геолокация",
  bots: "Бот",
}

interface IProps {}
interface IFormData extends ADV.Filters {}
export const OrderFilters = (props: IProps) => {
  const { data, isLoading } = useOrderFiltersListQuery({})
  const { read, write } = useUrlFilters(ORDER_FILTER_SCHEMA)
  const lastSyncedRef = useRef<ADV.Filters | null>(null)

  // The URL is the single source of truth: initialise the form from it and
  // mirror every change back so the active filters live in the link. The form
  // stores plain ids (matchId), so the parsed id arrays map directly.
  const formContext = useForm<IFormData>({ defaultValues: read() as IFormData })

  const watch = useWatch({ control: formContext.control }) as IFormData
  useEffect(() => {
    if (!formContext.formState.isDirty) return

    const cleaned = cleanFilters(watch)
    if (equal(cleaned, lastSyncedRef.current)) return
    lastSyncedRef.current = cleaned

    write(cleaned)
  }, [watch])

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" my={1}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <FormContainer formContext={formContext}>
      <Grid container spacing={1} alignItems="stretch" my={1}>
        {Object.keys(data ?? {}).map((key) => (
          <Grid item xs={12} sm={6} md={4} xl={2} key={`filter_${key}`}>
            <Filter
              name={key}
              label={FILTERS_LABELS[key]}
              isLoading={isLoading}
              multiple={true}
              options={data?.[key]}
            />
          </Grid>
        ))}
      </Grid>
    </FormContainer>
  )
}
